import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const BoardLevelFinancialAdvisory = () => {
  const serviceData = {
    title: "Board-Level Financial Advisory",
    heading: "Board-Level Financial Advisory",
    image: subTopicImages["Board-Level Financial Advisory"],
    intro:
      "Strategic financial guidance for leadership teams and boards. V DOOGAR AND ASSOCIATES provides senior-level financial advisory to help businesses make informed strategic decisions.",
    description:
      "Our board-level financial advisory services bring CFO-level expertise to your leadership discussions. We support boards and C-suite executives with strategic financial planning, capital allocation, risk assessment, and performance monitoring—ensuring financial discipline aligns with business strategy.",
    services: [
      {
        icon: "fi flaticon-strategy",
        title: "Strategic Planning",
        text: "Long-term financial strategy, scenario planning, and capital structure optimization.",
      },
      {
        icon: "fi flaticon-compliance",
        title: "Risk Oversight",
        text: "Financial risk assessment, internal controls review, and compliance monitoring.",
      },
      {
        icon: "fi flaticon-advisory",
        title: "Performance Monitoring",
        text: "KPI development, board reporting, and financial performance analysis.",
      },
    ],
    benefitsIntro: "Why choose our Board-Level Financial Advisory?",
    benefits: [
      [
        "CFO-level expertise for your board",
        "Strategic financial guidance",
        "Independent perspective on financial matters",
      ],
      [
        "Enhanced decision-making capability",
        "Improved governance and oversight",
        "Alignment of finance with strategy",
      ],
    ],
    research:
      "We work with boards across industries to provide independent financial perspective, ensuring that financial considerations are fully integrated into strategic planning and oversight.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default BoardLevelFinancialAdvisory;
